import * as React from 'react';

export const LoadAllSpeciesStep = () => {
  return loading;
};

const loading = <p>Loading species...</p>;
